import { render, staticRenderFns } from "./SelectAlert.vue?vue&type=template&id=19d44d1a&scoped=true&"
import script from "./SelectAlert.vue?vue&type=script&lang=js&"
export * from "./SelectAlert.vue?vue&type=script&lang=js&"
import style0 from "./SelectAlert.vue?vue&type=style&index=0&id=19d44d1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d44d1a",
  null
  
)

export default component.exports